"use client";

import { LightbulbIcon, LightbulbOffIcon } from "lucide-react";
import { motion } from "framer-motion";
import { useTheme } from "next-themes";
import { useEffect, useRef, useState } from "react";

export function ThemeToggle() {
  const { setTheme, theme } = useTheme();
  const [mounted, setMounted] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    setMounted(true);
  }, []);

  const toggleTheme = (e: React.MouseEvent) => {
    const newTheme = theme === "dark" ? "light" : "dark";

    // Use View Transition API for propagation effect if available
    const doc = document as any;
    if (doc.startViewTransition) {
      const x = e.clientX;
      const y = e.clientY;
      const endRadius = Math.hypot(
        Math.max(x, window.innerWidth - x),
        Math.max(y, window.innerHeight - y)
      );

      const transition = doc.startViewTransition(() => {
        setTheme(newTheme);
      });

      transition.ready.then(() => {
        document.documentElement.animate(
          {
            clipPath: [
              `circle(0px at ${x}px ${y}px)`,
              `circle(${endRadius}px at ${x}px ${y}px)`,
            ],
          },
          {
            duration: 500,
            easing: "ease-in-out",
            pseudoElement: "::view-transition-new(root)",
          }
        );
      });
    } else {
      setTheme(newTheme);
    }
  };

  if (!mounted) {
    return (
      <button type="button" className="pl-4">
        <LightbulbIcon className="size-4 inline-block dark:hidden stroke-[2.25px]" />
        <LightbulbOffIcon className="size-4 hidden dark:inline-block stroke-[2.25px]" />
      </button>
    );
  }

  return (
    <motion.button
      ref={buttonRef}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 1.2 }}
      type="button"
      className="pl-4"
      onClick={toggleTheme}
    >
      {theme === "light" && (
        <LightbulbIcon className="size-4 stroke-[2.25px]" />
      )}
      {theme === "dark" && (
        <LightbulbOffIcon className="size-4 stroke-[2.25px]" />
      )}
    </motion.button>
  );
}
